const IconVnFlag = ({
  width = 24,
  ...props
}) => {
  return <svg xmlns='http://www.w3.org/2000/svg' version='1.1' width={width} height={width} x='0' y='0' viewBox='0 0 36 36' {...props} data-sentry-element="svg" data-sentry-component="IconVnFlag" data-sentry-source-file="index.tsx">
      <g data-sentry-element="g" data-sentry-source-file="index.tsx">
        <g fillRule='evenodd' clipRule='evenodd' data-sentry-element="g" data-sentry-source-file="index.tsx">
          <path fill='#da251d' d='M18 0c9.94 0 18 8.06 18 18s-8.06 18-18 18S0 27.94 0 18 8.06 0 18 0z' opacity='1' data-original='#da251d' data-sentry-element="path" data-sentry-source-file="index.tsx"></path>
          <path fill='#ffff00' d='m10 15.75 4.944 3.592-1.888 5.812L18 21.563l4.944 3.592-1.89-5.812L26 15.75h-6.132L18 10l-1.868 5.75z' opacity='1' data-original='#ffff00' data-sentry-element="path" data-sentry-source-file="index.tsx"></path>
        </g>
      </g>
    </svg>;
};
export default IconVnFlag;